import React from 'react'
import './Heven.scss'
import HevenFoto from '../Images/heven-photo.avif'

const Heven = () => {
  return (
    <div className='full-width heven'>
        <div className='main-grid content'>
        <div className='client-description2'>
                <div className='client-foto'>
                    <img src={HevenFoto} alt='heven portfolio' />

                </div>
                <div className='client-text'>
                    <h4 className='client-name unbounded-font'>Heven</h4>
                        <p className='desc-big inter-font'>
                            For our international client, we took on the challenge of refreshing the visual page
                            and optimizing the visibility in search engines.
                        </p>
                        
                    
                        <p className='desc-small inter-font'>
                            The result was the implementation of a modern e-commerce system<br />
                            and a coherent visual identification system, which allowed the brand<br />
                            to build a strong image in the fashion world.
                        </p>
                        
                </div>
            </div>
        </div>
    </div>
  )
}

export default Heven